/*
 * Copyright (c) 2023 Bolmate B.V.
 */
import './style/bolOauth.scss';

import {AwesomeIcon, ErrorType, Loader, voidFunction, WithBackground} from '@dvrd/dvr-controls';
import classNames from 'classnames';
import React, {MouseEventHandler} from 'react';
import {APIValidationStatus} from "../../../util/interfaces";
import {BolmateButton} from "../../controls";
import {IconName} from '@fortawesome/fontawesome-svg-core';

interface Props {
    onClose: MouseEventHandler;
    onRetry: MouseEventHandler;
    status: APIValidationStatus;
    error: ErrorType;
}

export default function BolOauth(props: Props) {
    const {onClose, onRetry, status, error} = props;

    function renderStatus() {
        let statusLabel: string;
        if (status === APIValidationStatus.VALIDATING) statusLabel = 'Koppeling testen...';
        else if (status === APIValidationStatus.ERROR) statusLabel = 'Autorisatie mislukt';
        else statusLabel = 'Koppeling voltooid';
        return <label className='status-label'>{statusLabel}</label>;
    }

    function renderStatusIndicator() {
        let icon: IconName = 'circle-check';
        let iconClass = 'validated';
        if (status === APIValidationStatus.VALIDATING)
            return (
                <>
                    <Loader position='relative' active disableBackground/>
                    <label>Eén moment, we testen de verbinding.</label>
                </>
            );
        else if (status === APIValidationStatus.ERROR) {
            icon = 'circle-xmark';
            iconClass = 'error';
        }
        return <AwesomeIcon name={icon} className={classNames('status-indicator', iconClass)}/>;
    }

    function renderError() {
        if (!error) return null;
        return <label className='error-label'>{error}</label>;
    }

    function renderButton() {
        let label = 'Doorgaan';
        let onClick: MouseEventHandler = onClose;
        const disabled = status === APIValidationStatus.VALIDATING;
        const secondary = status === APIValidationStatus.ERROR;
        if (status === APIValidationStatus.ERROR) {
            label = 'Opnieuw proberen';
            onClick = onRetry;
        }
        return <BolmateButton onClick={onClick} label={label} disabled={disabled} secondary={secondary}/>;
    }

    return (
        <WithBackground onClose={voidFunction} backgroundColor='transparent' active preventBackgroundClick
                        escapeDisabled>
            <div className='bol-oauth default-popup'>
                <div className='header-container'>
                    <label className='header-title'>Koppeling met Bol</label>
                </div>
                <div className='body-container'>
                    {renderStatus()}
                    {renderStatusIndicator()}
                    {renderError()}
                    {renderButton()}
                </div>
            </div>
        </WithBackground>
    )
}